import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router'

import { rootRoute as baseRoute } from '@/tenant/root'

export const developerRootRoute = createRoute({
    getParentRoute: () => baseRoute,
    path: '/developer',
    component: lazyRouteComponent(() => import('./Root'), 'Root'),
    beforeLoad: async ({ location }): Promise<void> => {
        const [, tenantShortId, , subpath] = location.pathname.split('/')

        if (!subpath) {
            throw redirect({
                replace: true,
                to: '/$tenantShortId/developer/apiKeys',
                params: {
                    tenantShortId,
                },
            })
        }
    },
})
